import React, { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';

import { Button } from 'ui-components/components/button';
import { FlexColumn, Gap } from 'ui-components/components/flex';
import { createColumnDefinitionBuilder } from 'ui-components/components/react-table-wrapper/create-column-definition-builder';
import { Text, TextType } from 'ui-components/components/text';
import { useAsyncSafeState } from 'ui-components/hooks/async-safe';
import { THEME_CONSTANTS } from 'ui-components/services/button-theme-service';

import { SimpleModal } from '../../../../../../components/simple-modal';
import { useModal } from '../../../../../../hooks/use-modal';
import { messages } from '../messages';
import style from '../security.module.less';

const ActionButtonColumn = ({ row, onRemoveEnrollment, hasOneEnrollment }) => {
  const { id } = row.original;
  const { close, isOpen, open } = useModal();
  const [isDeleting, setIsDeleting] = useAsyncSafeState(false);

  const deleteEnrollment = useCallback(async () => {
    setIsDeleting(true);
    await onRemoveEnrollment(id);
    close();
  }, [close, id, onRemoveEnrollment, setIsDeleting]);

  return (
    <>
      <Button disabled={hasOneEnrollment} onClick={open} theme={THEME_CONSTANTS.link}>
        <FormattedMessage {...messages.buttonDelete} />
      </Button>

      {isOpen ? (
        <SimpleModal
          actionButtonTheme={THEME_CONSTANTS.danger}
          actionMessage={messages.buttonDelete}
          cancelMessage={messages.cancelButton}
          headerMessage={messages.deleteEnrollmentModalHeader}
          headerTextType={TextType.Description}
          isActionDisabled={isDeleting}
          onAction={deleteEnrollment}
          onCancel={close}
          size='medium'
        >
          <FlexColumn gap={Gap.Space8}>
            <Text textType={TextType.H3} value={messages.deleteEnrollmentModalH3} />
            <Text textType={TextType.Paragraph} value={messages.deleteEnrollmentModalParagraph} />
          </FlexColumn>
        </SimpleModal>
      ) : null}
    </>
  );
};

export const createActionButtonColumnDefinition = createColumnDefinitionBuilder({
  accessor: 'actions',
  className: style['action-button-column'],
  Header: (
    <div>
      <FormattedMessage {...messages.columnActionButton} />
    </div>
  ),
  Cell: ActionButtonColumn,
  width: 1,
});
